import { render } from "./ShapeSettings.vue?vue&type=template&id=82349062"
import script from "./ShapeSettings.vue?vue&type=script&lang=js"
export * from "./ShapeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__